var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Injectable } from '@angular/core';
import { BsDatepickerConfig } from './bs-datepicker.config';
var BsDaterangepickerConfig = (function (_super) {
    __extends(BsDaterangepickerConfig, _super);
    function BsDaterangepickerConfig() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // DatepickerRenderOptions
        _this.displayMonths = 2;
        return _this;
    }
    BsDaterangepickerConfig.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    BsDaterangepickerConfig.ctorParameters = function () { return []; };
    return BsDaterangepickerConfig;
}(BsDatepickerConfig));
export { BsDaterangepickerConfig };
//# sourceMappingURL=bs-daterangepicker.config.js.map


//////////////////
// WEBPACK FOOTER
// /app/SPA/~/ngx-bootstrap/datepicker/bs-daterangepicker.config.js
// module id = ../../../../ngx-bootstrap/datepicker/bs-daterangepicker.config.js
// module chunks = 4